// extracted by mini-css-extract-plugin
export default {"publishedVideoMain":"editor-publish-video_publishedVideoMain__ll87i","publishVideoTable":"editor-publish-video_publishVideoTable__B9UTj"};